module.exports = __webpack_public_path__ + "img/user-02.877d0a81.svg";